module.exports = {
    SecertKey: 'a342a8c0-4b07-4fa4-a93a-b05bb971f991',
    algorithm: "aes-256-cbc",
    Crypto_Secret: "abcdefghijklmnop",
}